import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M1,0h0.5v0.5h-0.5z' },
    {
      paint: 'trunk',
      d: 'M-0.5,-3.5h1v0.5h-1zM-1,-3h2.5v0.5h-2.5zM0,-2.5h1v0.5h-1zM0,-2h0.5v1h-0.5zM-1,-1h0.5v1h-0.5zM0,-1h1v1h-1zM-1,0h2v0.5h-2z',
    },
    { paint: 'stump', d: 'M-0.5,-2.5h0.5v2.5h-0.5z' },
    {
      paint: 'bushDark',
      d: 'M2.5,-7.5h1.5v0.5h-1.5zM1.5,-7h2.5v0.5h-2.5zM0.5,-6.5h3.5v1h-3.5zM0,-5.5h4v0.5h-4zM-1,-5h4.5v0.5h-4.5zM-1.5,-4.5h4.5v0.5h-4.5zM-2,-4h5v0.5h-5zM-2.5,-3.5h2v0.5h-2zM0.5,-3.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'leaf',
      d: 'M0,-10h1v0.5h-1zM-2.5,-9.5h1v0.5h-1zM-1,-9.5h3v0.5h-3zM-3,-9h0.5v0.5h-0.5zM1,-9h1.5v0.5h-1.5zM1,-8.5h2v0.5h-2zM-3.5,-8h0.5v1h-0.5zM-1,-8h4v0.5h-4zM-1.5,-7.5h4v0.5h-4zM-4,-7h5.5v0.5h-5.5zM-4,-6.5h4.5v1h-4.5zM-4,-5.5h4v0.5h-4zM-4,-5h3v0.5h-3zM-3.5,-4.5h2v0.5h-2zM-3,-4h1v0.5h-1z',
    },
    {
      paint: 'leafLight',
      d: 'M-1.5,-9.5h0.5v0.5h-0.5zM-2.5,-9h3.5v0.5h-3.5zM-3,-8.5h4v0.5h-4zM-3,-8h2v0.5h-2zM-3,-7.5h1.5v0.5h-1.5z',
    },
  ],
  pixels: 200,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M1,0h0.5v0.5h-0.5z' },
    {
      paint: 'trunk',
      d: 'M2,-4.5h0.5v0.5h-0.5zM-2,-4h1v0.5h-1zM1,-4h1.5v0.5h-1.5zM-1.5,-3.5h3.5v0.5h-3.5zM-1,-3h2.5v0.5h-2.5zM0,-2.5h1v0.5h-1zM0,-2h0.5v1h-0.5zM-1,-1h0.5v1h-0.5zM0,-1h1v1h-1zM-1,0h2v0.5h-2z',
    },
    { paint: 'stump', d: 'M-0.5,-2.5h0.5v2.5h-0.5z' },
    {
      paint: 'bushDark',
      d: 'M-1,-11.5h0.5v0.5h-0.5zM1,-11.5h0.5v0.5h-0.5zM-1.5,-11h0.5v0.5h-0.5zM1.5,-11h0.5v0.5h-0.5zM-2,-10.5h0.5v0.5h-0.5zM1.5,-10.5h1v1.5h-1zM-2.5,-10h0.5v2.5h-0.5zM1,-9h1.5v0.5h-1.5zM1.5,-8.5h1v1h-1zM-3,-7.5h1v0.5h-1zM1.5,-7.5h1.5v1.5h-1.5zM-3,-7h0.5v1h-0.5zM-3,-6h1v0.5h-1zM1,-6h2v0.5h-2zM-2.5,-5.5h0.5v0.5h-0.5zM0.5,-5.5h2v0.5h-2zM-2.5,-5h1v0.5h-1zM0,-5h2.5v0.5h-2.5zM-2,-4.5h4v0.5h-4zM-1,-4h2v0.5h-2z',
    },
    {
      paint: 'leaf',
      d: 'M-0.5,-11.5h1.5v0.5h-1.5zM0.5,-11h1v1.5h-1zM-2,-10h0.5v0.5h-0.5zM-1,-9.5h2.5v0.5h-2.5zM-1.5,-9h2.5v0.5h-2.5zM-2,-8.5h3.5v1.5h-3.5zM-2.5,-7h4v1h-4zM-2,-6h3v0.5h-3zM-2,-5.5h2.5v0.5h-2.5zM-1.5,-5h1.5v0.5h-1.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-1,-11h1.5v0.5h-1.5zM-1.5,-10.5h2v1h-2zM-2,-9.5h1v0.5h-1zM-2,-9h0.5v0.5h-0.5z',
    },
  ],
  pixels: 189,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M1,0h0.5v0.5h-0.5z' },
    {
      paint: 'trunk',
      d: 'M-2,-4h0.5v0.5h-0.5zM-1.5,-3.5h3.5v0.5h-3.5zM-1,-3h2.5v0.5h-2.5zM0,-2.5h1v0.5h-1zM0,-2h0.5v1h-0.5zM-1,-1h0.5v1h-0.5zM0,-1h1v1h-1zM-1,0h2v0.5h-2z',
    },
    { paint: 'stump', d: 'M-0.5,-2.5h0.5v2.5h-0.5z' },
    {
      paint: 'bushDark',
      d: 'M2,-8.5h1v0.5h-1zM3,-8h0.5v1h-0.5zM3,-7h1.5v0.5h-1.5zM2.5,-6.5h2.5v0.5h-2.5zM1,-6h4v0.5h-4zM0.5,-5.5h4.5v0.5h-4.5zM-2,-5h7v0.5h-7zM-3.5,-4.5h8v0.5h-8zM-3.5,-4h1.5v0.5h-1.5zM-1.5,-4h5v0.5h-5z',
    },
    {
      paint: 'leaf',
      d: 'M-2.5,-9h2.5v0.5h-2.5zM-3,-8.5h1v0.5h-1zM-0.5,-8.5h2.5v0.5h-2.5zM-4,-8h1v0.5h-1zM-0.5,-8h3.5v0.5h-3.5zM-5,-7.5h1v1h-1zM-2,-7.5h5v0.5h-5zM-3.5,-7h6.5v0.5h-6.5zM-5,-6.5h7.5v0.5h-7.5zM-5,-6h6v0.5h-6zM-5,-5.5h5.5v0.5h-5.5zM-5,-5h3v0.5h-3zM-4.5,-4.5h1v0.5h-1z',
    },
    {
      paint: 'leafLight',
      d: 'M-2,-8.5h1.5v0.5h-1.5zM-3,-8h2.5v0.5h-2.5zM-4,-7.5h2v0.5h-2zM-4,-7h0.5v0.5h-0.5z',
    },
  ],
  pixels: 212,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
